import React, {PureComponent} from 'react'
import SimpleUrlForm from "../forms/UrlForm/SimpleUrlForm";

class UrlButton extends PureComponent {

    state = {
        showForm: false,
    };

    handleClick = () => this.setState({
        showForm: !this.state.showForm
    });

    render() {
        const {className, children} = this.props;
        const {showForm} = this.state;

        return <span>
            <a onClick={this.handleClick} className={className}>{children}</a>
            {showForm && <SimpleUrlForm finishCallback={this.handleClick} />}
        </span>
    }
}

export default UrlButton